import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import * as Sentry from '@sentry/angular';
import {BehaviorSubject, catchError, EMPTY, map, Observable, throwError} from 'rxjs';
import {LoginViewModel} from '../../../../model/conta/login-view-model';
import {UsuarioViewModel} from '../../../../model/conta/usuario-view-model';
import {AppConfigurationService} from '../base/appConfiguration.service';

import {ToastrService} from 'ngx-toastr';
import {EsqueceuSenhaViewModel} from '../../../../model/conta/esqueceu-senha-view-model';
import {jwtAuthService} from './jwtAuthService';

@Injectable({
  providedIn: 'root',
})
export class ContaService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private toastr: ToastrService,
    private jwt: jwtAuthService,
  ) {
    // super(); this.jwt.sessaoService();
  }

  private _updateNameProfileUser = new BehaviorSubject<string>('');
  updateNameProfileUser = this._updateNameProfileUser.asObservable();

  onCadastrarUsuario(usuario: UsuarioViewModel): Observable<Number> {
    return this.httpClient.post<Number>(`${this.appConfigurationService.apiBaseUrl}/user/cadastro`, usuario).pipe(
      map(result => {
        return result;
      }),

      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  //Criar conta
  onCriarContaCliente(usuario: UsuarioViewModel): Observable<Number> {
    return this.httpClient.post<Number>(`${this.appConfigurationService.apiBaseUrl}/Auth/RegisterUser`, usuario).pipe(
      map(response => {
        return response;
      }),

      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  //
  //Resetar Senha
  onResetarSenha(usuario: any, id: string, captchaToken: any): Observable<any> {
    const headers = new HttpHeaders({
      'X-Recaptcha': captchaToken,
    });
    return this.httpClient
      .put<any>(`${this.appConfigurationService.apiBaseUrl}/Auth/ResetPassword?id=${id}`, usuario, {headers})
      .pipe(
        map(result => {
          return result;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  //
  //Atualizar dados do Usuario
  onUpdateUser(usuario: any, id: string): Observable<any> {
    return this.httpClient
      .put<any>(`${this.appConfigurationService.apiBaseUrl}/Auth/UpdateUser?id=${id}`, usuario)
      .pipe(
        map(result => {
          return result;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  //

  onConfirmEmail(token: any, id: any): Observable<any> {
    //  const headers = new HttpHeaders({
    //   'X-Recaptcha': captchaToken,
    // })
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Auth/ConfirmEmail?userId=${id}&token=${token}`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  onGetEmailByCPf(cpf: any, captchaToken: any): Observable<any> {
    const headers = new HttpHeaders({
      'X-Recaptcha': captchaToken,
    });
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Auth/GetEmailByCPf?cpf=${cpf}`, {headers})
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  onUpdateEmail(email: any, birtDay: any, cpf: any, captchaToken: any): Observable<any> {
    const headers = new HttpHeaders({
      'X-Recaptcha': captchaToken,
    });
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/Auth/UpdateEmail?email=${email}&birthDate=${birtDay}&cpf=${cpf}`,
        {headers},
      )
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  onLogin(login: LoginViewModel, captchaToken: any): Observable<Number> {
    const headers = new HttpHeaders({
      'X-Recaptcha': captchaToken,
    });
    return this.httpClient
      .post<Number>(`${this.appConfigurationService.apiBaseUrl}/Auth/LoginUser`, login, {headers})
      .pipe(
        map(token => {
          if (token) {
            let bearerToken = JSON.parse(JSON.stringify(token));
            window.localStorage.setItem('Bearer', bearerToken.token);
            const retornoDM = this.jwt.jwtDecodeToken(bearerToken.token);
            if (login) {
              Sentry.setUser({
                id: retornoDM.id,
                email: retornoDM.email,
                username: retornoDM.name,
              });
            }
          }
          return token;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  onEnviarEmailEsqueceuSenha(esqueceuSenhaVM: EsqueceuSenhaViewModel, captchaToken: any) {
    const headers = new HttpHeaders({
      'X-Recaptcha': captchaToken,
    });
    return this.httpClient
      .post<Number>(`${this.appConfigurationService.apiBaseUrl}/Auth/ForgotPassword`, esqueceuSenhaVM, {headers})
      .pipe(
        map(result => {
          return result;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  //Logout - e limpa o token da sesão
  onlogOut() {
    return new Promise(resolve => {
      window.localStorage.clear();
      Sentry.setUser(null);
      resolve(true);
    });
  }

  exbirErro(erro: any) {
    this.exibirMensagem('', erro);
    return EMPTY;
  }
  //dispara mensagem, lembrando de passar as props dele(tooster)
  exibirMensagem(titulo: string, mensagem: string): void {
    this.toastr.error(mensagem, titulo, {closeButton: true, progressBar: true});
  }

  onSendEmaiFaleConosco(model: UsuarioViewModel) {
    return this.httpClient
      .post<Number>(`${this.appConfigurationService.apiBaseUrl}/../SendEmailFaleConosco`, model)
      .pipe(
        map(result => {
          return result;
        }),

        catchError(err => {
          return throwError(() => new Error(err || 'Erro no servidor'));
        }),
      );
  }

  changeUserName(name: string) {
    this._updateNameProfileUser.next(name);
  }
}
